<template>
  <view-homepage />
</template>

<script setup>
import { onMounted } from 'vue';
import { useHead } from '#imports';
import { useStore } from 'vuex';
import { getMetadataAndTags } from '../helpers/metadata';
import ViewHomepage from '../components/ViewHomepage.vue';
import { clientWorkWindowEvent } from '../helpers/event-dispatch-helpers';

const store = useStore();
const metadata = getMetadataAndTags(store.state.settings.metadata, 'homepage', 'Home');

useHead({
  ...metadata.metaTitle,
  meta: metadata.metaTags,
});

onMounted(() => {
  clientWorkWindowEvent('homepage');
});
</script>
